var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _rect;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNavbarLogoYellow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 517.65074 97.837609",
    width: "5.3921952in",
    height: "1.0191418in",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs4"
  }, /*#__PURE__*/React.createElement("style", {
    id: "style2"
  }, ".cls-1{fill:#f7cc31;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title6"
  }, "pixelcities_elements") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title6"
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m 347.10076,56.517609 a 0.79,0.79 0 0 1 -0.78,-0.87 v -8.57 a 0.78,0.78 0 0 1 0.78,-0.87 h 9.34 a 0.78,0.78 0 0 1 0.77,0.87 v 8.57 a 0.78,0.78 0 0 1 -0.77,0.87 z m 83.85,0 a 0.78,0.78 0 0 1 -0.78,-0.87 v -8.57 a 0.78,0.78 0 0 1 0.78,-0.87 h 9.33 a 0.78,0.78 0 0 1 0.78,0.87 v 8.57 a 0.78,0.78 0 0 1 -0.78,0.87 z m -249.22,0 a 0.78,0.78 0 0 1 -0.78,-0.87 v -8.57 a 0.78,0.78 0 0 1 0.78,-0.87 h 9.33 a 0.78,0.78 0 0 1 0.78,0.87 v 8.57 a 0.78,0.78 0 0 1 -0.78,0.87 z",
    id: "path8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m 222.23076,96.937609 a 1.29,1.29 0 0 1 -1.16,-0.7 l -6.77,-10.27 h -0.08 l -6.69,10.27 a 1.51,1.51 0 0 1 -1.24,0.7 h -10 c -0.63,0 -0.78,-0.39 -0.55,-0.78 l 12.68,-18.74 -11.78,-17.35 c -0.23,-0.39 -0.07,-0.78 0.55,-0.78 h 10.11 a 1.46,1.46 0 0 1 1.32,0.7 l 5.68,8.87 h 0.08 l 5.72,-8.87 a 1.51,1.51 0 0 1 1.25,-0.7 h 10 c 0.7,0 0.86,0.39 0.62,0.78 l -11.68,17.35 12.68,18.74 c 0.23,0.39 0.07,0.78 -0.63,0.78 z",
    id: "path10"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m 241.64076,87.057609 a 27.09,27.09 0 0 1 -1.32,-8.94 27.88,27.88 0 0 1 1.24,-9 c 2.18,-6.76 8.17,-10.65 16.18,-10.65 8.32,0 14.08,4 16.26,10.58 0.78,2.48 1.24,5.21 1.24,11.58 a 0.76,0.76 0 0 1 -0.85,0.78 h -22.79 a 0.42,0.42 0 0 0 -0.47,0.47 8.1,8.1 0 0 0 0.47,2.1 c 1,3.27 3.89,5 7.77,5 a 12.12,12.12 0 0 0 8.64,-3.35 c 0.39,-0.31 0.78,-0.39 1.09,0 l 5.13,4.82 a 0.7,0.7 0 0 1 0.08,1.09 c -3.58,3.82 -9.1,6.3 -16,6.3 -8.58,-0.08 -14.49,-4.01 -16.67,-10.78 z m 22.4,-12.91 a 0.42,0.42 0 0 0 0.47,-0.47 9.48,9.48 0 0 0 -0.39,-2.8 c -0.86,-2.56 -3.19,-4.12 -6.3,-4.12 -3.11,0 -5.44,1.56 -6.3,4.12 a 9.48,9.48 0 0 0 -0.39,2.8 0.42,0.42 0 0 0 0.47,0.47 z",
    id: "path12"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m 299.00076,97.397609 c -8.32,0 -11.66,-3.65 -11.66,-12 v -40.57 a 0.73,0.73 0 0 1 0.78,-0.78 h 9.33 a 0.73,0.73 0 0 1 0.78,0.78 v 39.74 c 0,2.57 1,3.58 3.26,3.58 h 1.61 a 0.74,0.74 0 0 1 0.78,0.78 v 7.7 a 0.74,0.74 0 0 1 -0.78,0.77 z",
    id: "path14"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m 314.76076,87.137609 a 27.51,27.51 0 0 1 -1.17,-9 27.54,27.54 0 0 1 1.17,-9 c 2.25,-7 8.32,-10.65 16.25,-10.65 6.46,0 11.51,3 14.23,7.08 a 0.76,0.76 0 0 1 -0.15,1.09 l -6.77,4.43 a 0.77,0.77 0 0 1 -1.16,-0.16 c -1.64,-2.25 -3.27,-3.26 -6,-3.26 -2.88,0 -5,1.32 -5.84,4 a 19.55,19.55 0 0 0 -0.7,6.46 19.45,19.45 0 0 0 0.7,6.45 c 0.86,2.72 3,4 5.84,4 2.72,0 4.35,-1 6,-3.26 a 0.77,0.77 0 0 1 1.16,-0.16 l 6.78,4.47 a 0.75,0.75 0 0 1 0.15,1.09 c -2.72,4.12 -7.77,7.07 -14.23,7.07 -7.92,-0.03 -14.01,-3.65 -16.26,-10.65 z",
    id: "path16"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m 359.71076,96.937609 a 0.74,0.74 0 0 1 -0.78,-0.78 v -36.09 a 0.74,0.74 0 0 1 0.78,-0.78 h 9.39 a 0.73,0.73 0 0 1 0.77,0.78 v 36.09 a 0.73,0.73 0 0 1 -0.77,0.78 z",
    id: "path18"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m 398.44076,97.397609 c -8.71,0 -12,-3.88 -12,-12.52 v -17.12 a 0.41,0.41 0 0 0 -0.47,-0.46 h -2.33 a 0.74,0.74 0 0 1 -0.78,-0.78 v -6.45 a 0.73,0.73 0 0 1 0.78,-0.78 h 2.33 a 0.41,0.41 0 0 0 0.47,-0.46 v -10.07 a 0.73,0.73 0 0 1 0.77,-0.78 h 9.26 a 0.73,0.73 0 0 1 0.78,0.78 v 10.07 a 0.4,0.4 0 0 0 0.46,0.46 h 4.83 a 0.73,0.73 0 0 1 0.77,0.78 v 6.46 a 0.74,0.74 0 0 1 -0.77,0.78 h -4.83 a 0.4,0.4 0 0 0 -0.46,0.46 v 16.65 c 0,2.8 0.93,3.73 3.42,3.73 h 1.87 a 0.73,0.73 0 0 1 0.77,0.78 v 7.7 a 0.73,0.73 0 0 1 -0.77,0.77 z",
    id: "path20"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m 418.28076,96.937609 a 0.73,0.73 0 0 1 -0.78,-0.78 v -36.09 a 0.73,0.73 0 0 1 0.78,-0.78 h 9.33 a 0.73,0.73 0 0 1 0.78,0.78 v 36.09 a 0.73,0.73 0 0 1 -0.78,0.78 z",
    id: "path22"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m 441.96076,87.057609 a 27.09,27.09 0 0 1 -1.32,-8.94 27.88,27.88 0 0 1 1.24,-9 c 2.22,-6.79 8.22,-10.68 16.22,-10.68 8.32,0 14.08,4 16.26,10.58 0.78,2.48 1.24,5.21 1.24,11.58 a 0.76,0.76 0 0 1 -0.85,0.78 h -22.83 a 0.42,0.42 0 0 0 -0.47,0.47 8.1,8.1 0 0 0 0.47,2.1 c 1,3.27 3.89,5 7.77,5 a 12.12,12.12 0 0 0 8.64,-3.35 c 0.39,-0.31 0.78,-0.39 1.09,0 l 5.13,4.82 a 0.7,0.7 0 0 1 0.08,1.09 c -3.58,3.82 -9.1,6.3 -16,6.3 -8.53,-0.05 -14.53,-3.98 -16.67,-10.75 z m 22.4,-12.91 a 0.42,0.42 0 0 0 0.47,-0.47 9.48,9.48 0 0 0 -0.39,-2.8 c -0.86,-2.56 -3.19,-4.12 -6.3,-4.12 -3.11,0 -5.44,1.56 -6.3,4.12 a 9.48,9.48 0 0 0 -0.39,2.8 0.42,0.42 0 0 0 0.47,0.47 z",
    id: "path24"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m 483.73076,91.957609 a 0.76,0.76 0 0 1 0,-1.09 l 5.06,-5.68 a 0.75,0.75 0 0 1 1.09,0 19.62,19.62 0 0 0 11.51,4.13 c 4,0 5.83,-1.48 5.83,-3.58 0,-1.79 -1,-2.88 -5.37,-3.27 l -4.2,-0.47 c -7.93,-0.77 -12.28,-4.74 -12.28,-11.51 0,-7.38 5.67,-12 15.47,-12 a 25.53,25.53 0 0 1 15.26,4.62 0.84,0.84 0 0 1 0.08,1.16 l -4.36,5.37 a 0.75,0.75 0 0 1 -1.09,0.15 19.74,19.74 0 0 0 -10.19,-3 c -3.19,0 -4.74,1.25 -4.74,3.11 0,1.86 0.93,2.72 5.21,3.11 l 4.12,0.47 c 8.87,0.86 12.52,5.13 12.52,11.43 -0.07,7.7 -6.06,12.91 -16.8,12.91 -7.86,-0.06 -13.54,-2.75 -17.12,-5.86 z",
    id: "path26"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m 122.02076,96.937609 a 0.73,0.73 0 0 1 -0.78,-0.78 v -51.33 a 0.73,0.73 0 0 1 0.78,-0.78 h 20.53 c 11.51,0 18.43,6.92 18.43,17 0,10.08 -7,17 -18.43,17 h -9.45 a 0.41,0.41 0 0 0 -0.47,0.46 v 17.65 a 0.73,0.73 0 0 1 -0.78,0.78 z m 27.53,-35.86 c 0,-4.27 -2.88,-7.15 -7.7,-7.15 h -8.75 a 0.41,0.41 0 0 0 -0.47,0.46 v 13.3 a 0.41,0.41 0 0 0 0.47,0.47 h 8.71 c 4.86,0 7.74,-2.8 7.74,-7.08 z",
    id: "path28"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 168.96077,
    y: 59.287609,
    width: 10.89,
    height: 37.639999,
    rx: 0.77999997,
    id: "rect30"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M 69.55641,52.180987 71.77546,0 c 0,0 -20.804306,15.460358 -21.88647,40.945932 -1.082163,25.485576 11.490392,37.02461 11.490392,37.02461 l 8.170948,0.401254 z",
    id: "path42",
    style: {
      opacity: 0.5,
      fill: "#ffffff",
      fillOpacity: 1,
      strokeWidth: 0.607957
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M 59.525116,49.238475 32.623004,4.669113 c 0,0 -8.669475,24.70739 4.468477,46.47227 13.137964,21.76488 29.881109,24.166304 29.881109,24.166304 l 6.95504,-4.334737 z",
    id: "path44",
    style: {
      opacity: 0.5,
      fill: "#ffffff",
      fillOpacity: 1,
      strokeWidth: 0.607957
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M 52.187069,50.466545 5.374342,28.646961 c 0,0 6.353159,25.424779 29.212357,36.082271 22.859198,10.657492 38.076381,3.185693 38.076381,3.185693 l 3.41672,-7.538669 z",
    id: "path46",
    style: {
      opacity: 0.5,
      fill: "#ffffff",
      fillOpacity: 1,
      strokeWidth: 0.607957
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M 51.481837,60.564722 0,62.011662 c 0,0 16.779625,19.94708 41.918664,19.241859 C 67.05771,80.548289 77.45986,67.015155 77.45986,67.015155 l -0.22495,-8.298627 z",
    id: "path48",
    style: {
      opacity: 0.5,
      fill: "#ffffff",
      fillOpacity: 1,
      strokeWidth: 0.607957
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M 51.518313,74.110011 33.230961,97.686608 c 0,0 32.288609,0.656589 41.766669,-18.080659 C 84.47569,60.868701 85.02285,48.96489 94.93256,51.281217 l 20.06259,5.222353 a 0.31650361,0.31650361 0 0 0 0.17631,-0.607958 L 87.43037,44.95238 c 0,0 -9.35039,-3.763257 -14.30525,1.057842 -4.95485,4.821099 -21.606807,28.099789 -21.606807,28.099789 z",
    id: "path50",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      strokeWidth: 0.607957
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavbarLogoYellow);
export default __webpack_public_path__ + "static/media/navbar-logo-yellow.48dd68a10430d14863f86242d22bfc3c.svg";
export { ForwardRef as ReactComponent };